import ScrollTo from "@stimulus-components/scroll-to"

export default class extends ScrollTo {
  connect() {
    super.connect()
  }

  // You can set default options in this getter for all your anchors.
  get defaultOptions() {
    return {
      offset: 64,
      behavior: "smooth",
    }
  }
}
